import { MenuItem, Stack, TextField } from "@mui/material";
import { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { PlanReport } from "../components/reports/PlanReport";
import { foyerApi } from "../http/foyer";
import { useFormat } from "../i18n/format";

/**
 * Nenda staff: any provider's organisation-plan report (ORG-8), for the
 * settlement Nenda compiles (Upsales + Stripe) and sends the provider.
 */
export default function PlanReportsPage() {
  const { t } = useTranslation("analytics");
  const { locale } = useFormat();
  const [owners, setOwners] = useState<Array<{ id: string; name: string }>>([]);
  const [ownerId, setOwnerId] = useState("");
  useEffect(() => {
    foyerApi.listContentOwners().then(
      (list) => {
        const sorted = [...list].sort((a, b) =>
          a.name.localeCompare(b.name, locale)
        );
        setOwners(sorted);
        setOwnerId((cur) => cur || sorted[0]?.id || "");
      },
      () => setOwners([])
    );
  }, [locale]);
  const load = useCallback(
    (p: { from: string; to: string }) => foyerApi.planReport(ownerId, p),
    [ownerId]
  );
  return (
    <Stack spacing={3}>
      <TextField
        select
        size="small"
        label={t("planReportsPage.provider")}
        value={ownerId}
        onChange={(e) => setOwnerId(e.target.value)}
        sx={{ maxWidth: 320 }}
      >
        {owners.map((o) => (
          <MenuItem key={o.id} value={o.id}>
            {o.name}
          </MenuItem>
        ))}
      </TextField>
      {ownerId && <PlanReport key={ownerId} load={load} />}
    </Stack>
  );
}
